module.exports = __webpack_public_path__ + "static/media/3-3.5d10b0c7.jpg";